import React from 'react';
import OverWindow from '../../../Elements/TabList/OverWindow';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import UserLinkItem from '../../../Domain/UserLinkItem';
import UserLinkService from '../../../Services/UserLinkService';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditUserLinkWindowDescription from '../../../Elements/EditUserLinkWindowDescription';
import UserLinkSearchParams from '../../../Elements/UserLinkSearchParams';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import AuthService from '../../../Services/authService';
import ErrorMessage from '../../../Elements/ErrorMessage';

export default class UserLinkListComponent extends React.Component
{
  static defaultProps = {
    evaluator: {},
    clickOnCancel: () =>
    {
      alert('Missing function');
    },
    title: 'Evaluator Assignments',
    handleListItemOnChange: () => { },
  };

  constructor (props)
  {
    super(props);

    this.state = {
      itemList: [],
      selected: null,
      shownPanel: ShownPanelsEnum.Search,
      searchItem: new UserLinkSearchParams(),
    };

    UserLinkItem.editFunction = this.clickOnEdit.bind(this);
    UserLinkItem.deleteFunction = this.clickOnDelete.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.savePanelOnClose = this.savePanelOnClose.bind(this);
  }

  startSearch (searchItem)
  {
    this.setState({
      searchItem,
    });
  }

  clickOnDelete (selectedId, selectedItem)
  {
    ErrorMessage.SetApprove('Are you sure you want to delete this link?', () => this.clickOnApproveRemove(selectedId));
    this.setState({ selected: selectedItem });
  }

  clickOnApproveRemove (selectedId)
  {
    UserLinkService.DeleteUserLink(selectedId)
      .then(() => this.savePanelOnClose())
      .catch(() => ErrorMessage.SetErrorMessage('SA54'));
  }

  clickOnEdit (selectedItem)
  {
    // console.log(selectedItem);
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selected: { ...selectedItem },
    });
  }

  savePanelOnClose ()
  {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    this.props.handleListItemOnChange();
  }

  renderPanels ()
  {
    if (this.state.shownPanel === ShownPanelsEnum.EditItem)
    {
      const editedUserLink = { ...this.state.selected };
      editedUserLink.HasAdminRole = AuthService.HasRole('UserLinkAdmin');

      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={editedUserLink}
          clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
          clickOnSave={this.savePanelOnClose}
          windowDescription={EditUserLinkWindowDescription}
          errorCode='ULLC57'
        />
      );
    } else if (this.state.shownPanel === ShownPanelsEnum.AddNewItem)
    {
      const newUserLinkItem = new UserLinkItem();
      newUserLinkItem.HasAdminRole = AuthService.HasRole('UserLinkAdmin');
      newUserLinkItem.IsActive = true;
      newUserLinkItem.Target = '_blank';
      newUserLinkItem.Order = 1;

      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={newUserLinkItem}
          clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
          clickOnSave={this.savePanelOnClose}
          windowDescription={EditUserLinkWindowDescription}
          errorCode='ULLC77'
        />
      );
    }
  }

  showPanel (panelId)
  {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderButtonsAndPanels ()
  {
    return (
      <>
        <ButtonRow
          tooltips={[ 'Create' ]}
          colors={[ ButtonColorsEnum.Primary ]}
          keys={[ ShownPanelsEnum.AddNewItem ]}
          icons={[ 'fa-solid fa-plus-circle' ]}
          className={'InnerMenuButtonFigmaList'}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  render ()
  {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={'Edit Links'}
        closeOnClickOutside={false}
        verticalScroll={false}
        bothScroll={true}
      >
        {this.renderButtonsAndPanels()}
        <div className='verticalScroll showassignmentlistheight'>
          <TabOfDataTable
            type={UserLinkItem}
            shownPanel={this.state.shownPanel}
            serviceFunction={UserLinkService.GetUserLinks}
            convertDBItemsFunction={UserLinkService.ConvertDBItemList}
            searchItem={this.state.searchItem}
            errorCode='ULLC95'
            searchParamsType={UserLinkSearchParams}
            showSearchStrip={true}
            enableUrlPush={false}
            clickOnStartSearch={this.startSearch}
          />
        </div>
      </OverWindow>
    );
  }
}
